import "./native-toolbar-entrance.css";

/** Same one-time sequence as the original editor; interaction ends it
 * immediately so a moving icon never delays opening its tool or menu. */
export function installNativeToolbarEntrance() {
  const root = document.getElementById("native-editor")!;
  const toolbar = root.querySelector<HTMLElement>(".native-toolbar-row")!;
  const finish = () => {
    delete root.dataset.dockEntering;
    clearTimeout(timer);
    toolbar.removeEventListener("pointerdown", finish, true);
    toolbar.removeEventListener("focusin", finish, true);
  };
  const timer = setTimeout(finish, 5300);
  if (matchMedia("(prefers-reduced-motion: reduce)").matches) {
    finish();
    return;
  }
  toolbar.addEventListener("pointerdown", finish, true);
  toolbar.addEventListener("focusin", finish, true);
}
